export default __webpack_public_path__ + "static/media/emed-logo-splash-png.4ebfd171.png";